<div class="form-field {{ formControl.status | lowercase }}">
	<label *ngIf="label">{{ label }} <span class="required" *ngIf="requiredIcon">*</span> <span *ngIf="hint" class="tooltip" [matTooltip]="hint" [matTooltipPosition]="'right'"></span></label>
	<div class="form-input-container">
		<textarea
			[name]="name"
			[readOnly]="readonly"
			[placeholder]="placeholder"
			[formControl]="formControl"
			(click)="click.emit($event)"
			(keydown)="keydown.emit($event)"></textarea>
	</div>
</div>
